export function goToNextSalonBookingPage(to?: string) {
  const { $i18n } = useNuxtApp();
  const router = useRouter();
  const { getCurrentFlow } = useBookingStore();

  const pageIsInFlow = getCurrentFlow.indexOf(to || router.currentRoute.value.path);

  if (pageIsInFlow !== -1) {
    return navigateTo(getCurrentFlow[pageIsInFlow + 1]);
  } else {
    return navigateTo($i18n.t('url.booking.start'));
  }
}

export function filterSalonData(salon: Record<string, any>) {
  const salonData: Record<string, any> = {};
  salonData.address = '';
  const address = salon?.address;

  if (address) {
    // eslint-disable-next-line max-len
    salonData.address = `${address.line1}${address.line2 ? ' ' + address.line2 : ''}, ${address.postalCode} ${address.town}`;
  }

  salonData.storeNumber = salon?.storeNumber;
  salonData.features = salon?.features?.entry.filter((salonFeature: Record<string, any>) =>
    salonFeature.key.includes('salon'),
  );

  const petTypes: string[] = salon.salon.servedPetTypes?.map((type: string) => type.toLowerCase()) || [];

  if (petTypes.length > 1) {
    petTypes.splice(0, 2, petTypes[1], petTypes[0]);
  }
  salonData.servedPetTypes = petTypes;

  if (salon.salon.priceGroup) {
    salonData.priceGroup = salon.salon.priceGroup;
  }

  if (salon.salon.name) {
    salonData.salonName = salon.salon.name;
  }

  return salonData;
}
